import WelcomeCard from "~/components/organisms/WelcomeCard/WelcomeCard";

const Welcome = () => {
  return <WelcomeCard />;
};

export default Welcome;
